// extracted by css-extract-rspack-plugin
export default {"empty-state":"Q36ts6","emptyState":"Q36ts6"};